// extracted by mini-css-extract-plugin
export var controlls = "ArticlesCarousel-module--controlls--stsdq";
export var header = "ArticlesCarousel-module--header--yr3Mv";
export var progress = "ArticlesCarousel-module--progress--5NTQy";
export var progressVal = "ArticlesCarousel-module--progressVal--lQPHM";
export var slider = "ArticlesCarousel-module--slider--qzpTE";
export var texts = "ArticlesCarousel-module--texts--KSyC3";
export var wrapper = "ArticlesCarousel-module--wrapper--Y9u-v";